import gql from 'graphql-tag';

export const CHANGE_EMAIL_TMP = gql`
    mutation($email: String!, $email_confirmation: String!) {
        changeEmailTmp(email: $email, email_confirmation: $email_confirmation)
    }
`;

export const CHANGE_EMAIL = gql`
    mutation($url_token: String!) {
        changeEmail(url_token: $url_token) {
            accessToken
        }
    }
`;

export const UPDATE_MEMBER_INFO = gql`
    mutation (
        $member_no: String!,
        $family_name: String!,
        $given_name: String!,
        $family_name_kana: String!,
        $given_name_kana: String!,
        $zipcode: String,
        $address1: String,
        $address2: String,
        $gender: Int!,
        $birth_date: String!
    ) {
        memberUpdateInfo(
            member_no: $member_no
            family_name: $family_name
            given_name: $given_name
            family_name_kana: $family_name_kana
            given_name_kana: $given_name_kana
            zipcode: $zipcode
            address1: $address1
            address2: $address2
            gender: $gender
            birth_date: $birth_date
        ){
            result
        }
    },
`;
